module.exports = __webpack_public_path__ + "static/media/synkd_logo_small.d7b12755.png";